import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  HContainer,
  Image,
  Text,
  VContainer,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../../constants';

export const ItemCard = (props) => {

  return (

    <VContainerVH
      ref={props.refs}
      width={props.width}
      minWidth={props.minWidth}
      height={props.height}
      margin={props.margin}
      padding={props.padding}
      position={'relative'}
      boxSizing={'border-box'}
      border={props.border}
      borderRadius={'6px'}
      boxShadow={props.boxShadow}
      onClick={props.onClick}>

      { props.badgeText &&

          <HContainer
            top={'-1px'}
            left={'-1px'}
            position={'absolute'}
            padding={'4px 10px'}
            borderRadius={'5px 0 5px 0'}
            backgroundColor={CustomColors.Green5}>

            <Text
              color={CustomColors.White}
              fontWeight={'bold'}
              fontSize={'8px'}>

              {props.badgeText}
            </Text>
          </HContainer>
        }

      <Image
        src={props.iconUrl}
        width={'45px'}
        height={'45px'}/>

      <Text
        fontSize={'18px'}
        fontWeight={'500'}
        color={CustomColors.Grey9}
        textAlign={'center'}>

        {props.text}
      </Text>

      { props.isSelected &&

        <>
          <VContainer
            position={'absolute'}
            top={'0'}
            right={'0'}
            width={'0'}
            height={'0'}
            borderTop={`27px solid ${CustomColors.Blue2}`}
            borderLeft={`27px solid ${CustomColors.Transparent}`}>

          </VContainer>

          <VContainer
            position={'absolute'}
            top={'2px'}
            right={'2px'}>

            <ColorSvg
              src={Icons.Checkmark}
              color={CustomColors.White}
              width={'11px'}
              height={'11px'}/>

          </VContainer>
        </>
      }
    </VContainerVH>
  );
};

ItemCard.propTypes = {
  width: PropTypes.string,
  minWidth: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  boxShadow: PropTypes.string,
  border: PropTypes.string,
  text: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  badgeText: PropTypes.string,
  onClick: PropTypes.func
};

ItemCard.defaultProps = {
  width: '108px',
  minWidth: '108px',
  height: '104px',
  margin: '0 5px',
  padding: '5px',
  boxShadow: `0px 4px 4px ${CustomColors.TransparentBlack1}`,
  border: '',
  text: 'Food',
  iconUrl: Icons.VoucherCategoryDefaultImage,
  isSelected: false,
  badgeText: '',
  onClick: () => {}
};
